import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import BlinkitOnboardingApi from "../../services/api/BlinkitOnboarding";

const handleError = (err) => {
  console.log("[BlinkitOnboarding] Error in fetching upload url", err);
};

export const getUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await BlinkitOnboardingApi.getUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
